import React from 'react'

const TakingNotes = ({
  fill = 'black',
  width
}: {
  fill?: string
  width?: string
}) => (
  <svg
    width={width || '24px'}
    height={width || '24px'}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="20" width="21" height="2" fill={fill} />
    <path
      d="M5.88459 5.81189C5.92423 5.70475 6.07577 5.70475 6.11541 5.81189C6.12787 5.84557 6.15443 5.87213 6.18811 5.88459C6.29525 5.92423 6.29525 6.07577 6.18811 6.11541C6.15443 6.12787 6.12787 6.15443 6.11541 6.18811C6.07577 6.29525 5.92423 6.29525 5.88459 6.18811C5.87213 6.15443 5.84557 6.12787 5.81189 6.11541C5.70475 6.07577 5.70475 5.92423 5.81189 5.88459C5.84557 5.87213 5.87213 5.84557 5.88459 5.81189Z"
      fill={fill}
    />
    <path
      d="M7 13.6691V17.0025H10.3334L20.1647 7.17122L16.8313 3.83783L7 13.6691ZM22.7425 4.5934C23.0892 4.24672 23.0892 3.68671 22.7425 3.34004L20.6625 1.26C20.3158 0.913332 19.7558 0.913332 19.4091 1.26L17.7824 2.8867L21.1158 6.22009L22.7425 4.5934Z"
      fill={fill}
    />
    <path
      d="M19.8846 13.8119C19.9242 13.7048 20.0758 13.7048 20.1154 13.8119C20.1279 13.8456 20.1544 13.8721 20.1881 13.8846C20.2952 13.9242 20.2952 14.0758 20.1881 14.1154C20.1544 14.1279 20.1279 14.1544 20.1154 14.1881C20.0758 14.2952 19.9242 14.2952 19.8846 14.1881C19.8721 14.1544 19.8456 14.1279 19.8119 14.1154C19.7048 14.0758 19.7048 13.9242 19.8119 13.8846C19.8456 13.8721 19.8721 13.8456 19.8846 13.8119Z"
      fill={fill}
    />
  </svg>
)

export default TakingNotes
